import { _IS_TEMP_ENVIRONMENT } from '@js/temp/gambi';

const BANKS = {
  BRADESCO: {
    code: '394',
    name: 'Bradesco',
  },
  BV: {
    code: '655',
    name: 'BV',
  },
  CREDITAS: {
    code: '342',
    name: 'Creditas',
  },
  C6: {
    code: '336',
    name: 'C6',
  },
  FONTECRED: {
    code: 'fontecred',
    name: 'Fontecred',
  },
  HONDA: {
    code: 'M22',
    name: 'Honda',
  },
  HYUNDAI: {
    code: 'M26',
    name: 'Hyundai',
  },
  ITAU: {
    code: '341',
    name: 'Itaú',
  },
  KUNA: {
    code: 'kuna',
    name: 'Kuna',
  },
  MONEYPLUS: {
    code: 'moneyplus',
    name: 'AutoBanking',
  },
  PAN: {
    code: '623',
    name: 'Pan',
  },
  SAFRA: {
    code: '422',
    name: 'Safra',
  },
  SANTANDER: {
    code: '033',
    name: 'Santander',
  },
  VOLKSWAGEN: {
    code: 'M14',
    name: 'Volkswagen',
  },
};

if (_IS_TEMP_ENVIRONMENT()) {
  BANKS.STELLANTIS = {
    code: 'M24',
    name: 'Stellantis',
  };
}

export const BANK_VALUES = Object.values(BANKS);
export const BANK_CODES = BANK_VALUES.map((bank) => bank.code);

export function BANK_FINDER(code) {
  return BANK_VALUES.find((bank) => bank.code === code);
}

export function BANK_UNION(codes) {
  let bankCodes = (typeof codes === 'string' && /,/.test(codes)) ? codes.split(',') : codes;

  if (bankCodes && !Array.isArray(bankCodes)) {
    bankCodes = [bankCodes];
  }

  if (!bankCodes?.length || bankCodes.some((code) => !BANK_CODES.includes(code))) {
    return [...BANK_CODES];
  }

  return [...bankCodes];
}

export function BANK_EXCLUSION(min = [], max = []) {
  return min.filter((code) => max.includes(code));
}

export default BANKS;
